import React, { useCallback, useEffect, useState } from "react";
import { Topbar } from "@components";
import { message, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import moment from "moment";
import { LIMITS } from "@constants";
import { NoFriendIcon } from "@assets";

import {
  RootContainer,
  SpinWrapper,
  OuterDiv,
  FriendInfo,
  InfoText,
  Title,
  Number,
  Heading,
  FriendListContiner,
  LeftSection,
  DateText,
  NoFriendWrapper,
  InviteText,
  NumOfFriend,
} from "./FriendList.style";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";


const { DEFAULT_PAGE, PAGE_SIZE } = LIMITS;

const FriendList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [dataLength, setDataLength] = useState(0);

  const getFriendList = useCallback(() => {
    api
      .getFriends({
        page,
        limit: PAGE_SIZE,
      })
      .then(({ users, pagination }) => {
        setDataLength(pagination.total);
        if (page === 1) {
          setData(users);
        } else {
          setData((prev) => [...prev, ...users]);
        }
        // setData([
        // 	{
        // 		user_id: "usr-00000-00000-00000-00000",
        // 		name: "Dummy Name",
        // 		phone: "********00",
        // 		created_at: 1600000000,
        // 	},
        // 	{
        // 		user_id: "usr-00000-00000-00000-00000",
        // 		name: "Dummy Name",
        // 		phone: "********00",
        // 		created_at: 1600000000,
        // 	},
        // 	{
        // 		user_id: "usr-00000-00000-00000-00000",
        // 		name: "Dummy Name",
        // 		phone: "********00",
        // 		created_at: 1600000000,
        // 	},
        // 	{
        // 		user_id: "usr-00000-00000-00000-00000",
        // 		name: "Dummy Name",
        // 		phone: "********00",
        // 		created_at: 1600000000,
        // 	},
        // 	{
        // 		user_id: "usr-00000-00000-00000-00000",
        // 		name: "Dummy Name",
        // 		phone: "********00",
        // 		created_at: 1600000000,
        // 	},
        // 	{
        // 		user_id: "usr-00000-00000-00000-00000",
        // 		name: "Dummy Name",
        // 		phone: "********00",
        // 		created_at: 1600000000,
        // 	},

        // 	{
        // 		user_id: "usr-00000-00000-00000-00000",
        // 		name: "Dummy Name",
        // 		phone: "********00",
        // 		created_at: 1600000000,
        // 	},
        // ]);
        setLoading(false);
      })
      .catch((errorMsg) => {
        setLoading(false);
        message.error(errorMsg);
      });
  }, [page]);

  useEffect(() => {
    getFriendList();
  }, [getFriendList]);

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.PROFILE}`);
  };

  const renderTop = () => (
    <Heading>
      <Title>
        {t("profile.friendListHeading1")}  
      </Title>
      <NumOfFriend> {data.length} </NumOfFriend>
    </Heading>
  );

  const FriendCard = ({ friend, index }) => {
    return (
      <OuterDiv>
        <LeftSection>
          <Number>{index + 1 + "."}</Number>
          <FriendInfo>
            <InfoText isName={true}>{friend.name}</InfoText>
            <InfoText>{`*******${friend.phone.substr(-4)}`}</InfoText>
          </FriendInfo>
        </LeftSection>
        <DateText>
          {moment.unix(friend.created_at).format("MMM DD, YYYY")}
        </DateText>
      </OuterDiv>
    );
  };

  return (
    <RootContainer>
      <Topbar
        title={t("profile.friendListTitle")}
        goBack={goBack}
        shadow={false}
      />
      {renderTop()}
      {data.length === 0 ? (
        <NoFriendWrapper>
          <NoFriendIcon style={{width: 92, height:92,}} />
          <InviteText>{t("profile.noInviteFriend")}</InviteText>
        </NoFriendWrapper>
      ) : (
        <div
          id="scrollableDiv"
          style={{
            height: "calc(100vh - 170px)",
            overflowY: "auto",
          }}
        >
          <InfiniteScroll
            dataLength={data.length}
            next={() => {
              setPage((prev) => prev + 1);
            }}
            hasMore={loading || data.length !== dataLength}
            loader={
              <SpinWrapper>
                <Spin size="small" />
              </SpinWrapper>
            }
            scrollableTarget="scrollableDiv"
            style={{
              padding: "0 20px",
              borderRadius: "10px",
            }}
          >
            <FriendListContiner>
              {data.map((friend, index) => (
                <FriendCard friend={friend} index={index} key={index} />
              ))}
            </FriendListContiner>
          </InfiniteScroll>
        </div>
      )}
    </RootContainer>
  );
};

export default FriendList;
